import { zones } from 'Helpers/dates'
import {
  Button,
  FormElement,
  Grid,
  GRID_VARIANT_VERTICAL_BIG,
  GridCell,
  InputText,
  Panel,
  Select,
  SPACING_32,
  SpacingVertical,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'
import {
  changeWizardStepCallback,
  saveTaskCallback
} from 'Pages/Task/recoil/callbacks/callbacks'
import { pageState, step1IsEnabledState } from 'Pages/Task/recoil/state/page'
import { taskState } from 'Pages/Task/recoil/state/task'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'

import InputTags from './InputTags'

const TaskStep1 = () => {
  const intl = useIntl()
  const [{ Name, nameIsDiry, Description, CustomerTimeZone }, setTastState] =
    useRecoilState(taskState)
  const step1IsEnabled = useRecoilValue(step1IsEnabledState)
  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])
  const { idTask } = useRecoilValue(pageState)
  const saveTask = useRecoilCallback(saveTaskCallback, [])

  const onChangeName = (e) => {
    setTastState((prev) => ({
      ...prev,
      Name: e.target.value,
      nameIsDiry: true,
      isDirty: true
    }))
  }

  const onChangeDescription = (e) => {
    setTastState((prev) => ({
      ...prev,
      Description: e.target.value,
      isDirty: true
    }))
  }

  function onInputTagChange(value) {
    setTastState((prev) => ({
      ...prev,
      Tags: value,
      isDirty: true
    }))
  }

  const handleChangeTimeZone = (value) => {
    if (value) {
      setTastState((prev) => ({
        ...prev,
        CustomerTimeZone: value,
        isDirty: true
      }))
    }
  }

  const handleClick = () => {
    if (idTask > 0) {
      saveTask(false)
    } else {
      changeWizardStep(2)
    }
  }

  return (
    <>
      <Panel>
        <Title variant={TITLE_VARIANT_M}>
          {intl.formatMessage({ id: 'Load.Task.Step1InfoGeneral' })}
        </Title>
        <SpacingVertical variant={SPACING_32} />
        <Grid cols={3} variantVertical={GRID_VARIANT_VERTICAL_BIG}>
          <GridCell>
            <FormElement
              label={intl.formatMessage({ id: 'Load.MailupCommon.Name' })}
              required
              feedback={
                !Name && nameIsDiry
                  ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                  : null
              }
            >
              <InputText
                placeholder={intl.formatMessage({
                  id: 'Load.Task.NamePlaceholder'
                })}
                autoComplete='off'
                onChange={onChangeName}
                value={Name}
                data-mu-test='input-name'
                maxLength='100'
                variant={!Name && nameIsDiry ? 'danger' : ''}
              />
            </FormElement>
          </GridCell>
          <GridCell>
            <FormElement
              labelFor='input-Description'
              label={intl.formatMessage({
                id: 'Load.MailupCommon.Description'
              })}
            >
              <InputText
                id='input-Description'
                placeholder={intl.formatMessage({
                  id: 'Load.Task.DescriptionPlaceholder'
                })}
                onChange={onChangeDescription}
                value={Description}
                data-mu-test='input-Description'
              />
            </FormElement>
          </GridCell>
          <GridCell>
            <InputTags onChange={(value) => onInputTagChange(value)} />
          </GridCell>
          <GridCell>
            <FormElement
              label={intl.formatMessage({ id: 'Load.Task.DefaultTimeZone' })}
              hint={intl.formatMessage({
                id: 'Load.TriggersDetail.LegalHourAuto'
              })}
            >
              <Select
                value={CustomerTimeZone}
                onChange={handleChangeTimeZone}
                searchable
                disabled={false}
                placeholder={intl.formatMessage({
                  id: 'Load.Task.TimeZonePlaceholder'
                })}
                options={Object.entries(zones).map(([code, label]) => ({
                  value: code,
                  label: `(${code.replace(/([^.]+)\.\d+$/, '$1')}) ${label}`
                }))}
                data-mu-test='select-CustomerTimeZone'
              />
            </FormElement>
          </GridCell>
        </Grid>
      </Panel>

      <Button
        kind='primary'
        disabled={!step1IsEnabled}
        onClick={() => handleClick()}
        data-mu-test='task-1-btn-goto-next-step'
      >
        {idTask > 0
          ? intl.formatMessage({ id: 'Load.Task.SaveTask' })
          : intl.formatMessage({ id: 'Load.Task.Next' })}
      </Button>
    </>
  )
}

export default TaskStep1
